/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('variant:changed', function (event) {
	const container = event.target;
	const variant = event.detail.variant;
	const stickyVariantTitle = container.querySelector('.product-form__mobile-sticky-variant');
	const stickyInventory = container.querySelector('.product-form__mobile-sticky-inventory');
	const productInventory = container.querySelector('.product-form__inventory');

	if (variant && stickyVariantTitle) {
		const maxCharacters = Number(stickyVariantTitle.dataset.maxCharacters) || 30;
		const title = stickyVariantTitle.dataset.hasOnlyDefaultVariant === 'true'
			? stickyVariantTitle.dataset.productTitle
			: variant.title;
		stickyVariantTitle.textContent = title.length > maxCharacters
			? `${title.slice(0, maxCharacters - 1)}…`
			: title;
		stickyVariantTitle.title = title;
	}

	if (stickyInventory && productInventory) {
		stickyInventory.textContent = productInventory.textContent;
		stickyInventory.className = productInventory.className.replace(
			'product-form__inventory',
			'product-form__mobile-sticky-inventory'
		);
	}

	const quantityDropdown = container.querySelector('.js-quantity-dropdown');
	const productJsonElement = container.querySelector('[data-product-json]');
	if (productJsonElement && quantityDropdown) {
		const jsonData = JSON.parse(productJsonElement.innerHTML);
		const variantInventory = jsonData['inventories'][variant.id];

		if (variantInventory) {
			const variantQuantity = variantInventory['inventory_quantity'];
			if (variantQuantity > 0) {
				quantityDropdown.innerHTML = '';
				for (let i = 1; i <= variantQuantity; i++) {
					let option = document.createElement(`option`);
					option.setAttribute('value', `${i}`);
					option.innerText = `${i}`;
					if (i === 1) {
						option.setAttribute('selected', 'selected');
					}
					quantityDropdown.append(option);
				}
			}
		}
	}
});


document.addEventListener('DOMContentLoaded', function () {
	const stickyProductForm = document.querySelector('.h-product-template--static .product-form--mobile-sticky-actions');
	const socialsRow = document.querySelector('.c-socials-row');
	const mobileMedia = window.matchMedia('(max-width: 640px)');

	if (!stickyProductForm) {
		return;
	}

	const stickyInventory = stickyProductForm.querySelector('.product-form__mobile-sticky-inventory');
	const productInventory = stickyProductForm.querySelector('.product-form__inventory');
	if (stickyInventory && productInventory) {
		stickyInventory.textContent = productInventory.textContent;
		stickyInventory.className = productInventory.className.replace(
			'product-form__inventory',
			'product-form__mobile-sticky-inventory'
		);
	}

	if (!socialsRow) {
		return;
	}

	let socialsRowIsVisible = false;
	const updateStickyBarVisibility = function () {
		document.body.classList.toggle('mobile-pdp-bar-hidden', mobileMedia.matches && socialsRowIsVisible);
	};

	const socialsObserver = new IntersectionObserver(function (entries) {
		socialsRowIsVisible = entries[0].isIntersecting;
		updateStickyBarVisibility();
	});

	socialsObserver.observe(socialsRow);
	mobileMedia.addEventListener('change', updateStickyBarVisibility);
});



document.addEventListener("DOMContentLoaded", function() {
  
    // newsletter forms ajax
  
	const newsletterForms = document.querySelectorAll('form[id*="newsletter"]');

	newsletterForms.forEach(function(formElem) {
		formElem.addEventListener('submit', function(e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			e.stopPropagation();

			const formUrl = formElem.getAttribute('action');
			const formId = formElem.getAttribute('id');
			const formData = new FormData(formElem);
			const submitButton = formElem.querySelector('[type="submit"]');

			submitButton.classList.add('is-loading');

			fetch(formUrl, {
				method: 'POST',
				headers: {'X-Requested-With': 'XMLHttpRequest'},
				credentials: 'include',
				body: formData
			}).then(response => {
				if (response.ok) {
					return response.text();
				} else if (response.status === 429) {
					// window.location = `${window.location.origin}/challenge#${formId}`;
					throw response;
				} else {
					throw response;
				}
			}, function(error) {
				console.error(error);
			}).then(responseHtml => {
				let responseDocumentElement = document.createElement('div');
				responseDocumentElement.innerHTML = responseHtml;
				let responseFormElement = responseDocumentElement.querySelector(`form[id="${formId}"]`);
				formElem.innerHTML = responseFormElement.innerHTML;
			}).catch(error => {
				console.error(error);
			}).finally(() => {
				submitButton.classList.remove('is-loading');
			})
		})
	});
  
    addZoomingForCollectionProductsImages();


  // Collection list. Product grid. Show preorder text for Mobile template

  /*
  let checkPreorderText = setInterval(function() {
    let productForms = document.querySelectorAll('.product-list-new .product-list__item');
    productForms.forEach(function(form) {
      let preorderTextEl = form.closest('.product-list__item').querySelector('.product-list__item-preorder-text');
      if(preorderTextEl) {
        let preorderInput = form.querySelector('input[name="properties[_is_preorder]"]');
        if(preorderInput && preorderInput.value) {
          preorderTextEl.classList.remove('empty');
          preorderTextEl.innerText = preorderInput.value;
        } else {
          preorderTextEl.classList.add('empty');
          preorderTextEl.innerText = '';
        }
      }
    });
  }, 2000);
  */


  /* Header. Main menu. Add scrollable feature */

  let waitForMenus = setInterval(function() {
    let desktopNavigation = document.querySelectorAll('.tmenu_item--root > .tmenu_submenu');
    if(desktopNavigation && desktopNavigation.length) {
      clearInterval(waitForMenus);
      let header = document.querySelector('#shopify-section-header > section > header');
      let announceBar = document.querySelector('#shopify-section-announcement-bar');
      desktopNavigation.forEach(function(menu) {
        let heightToTakeOff = 0;
        if(header) heightToTakeOff = heightToTakeOff + header.offsetHeight;
        if(announceBar) heightToTakeOff = heightToTakeOff + announceBar.offsetHeight;
        menu.style.maxHeight = 'calc(100vh - '+heightToTakeOff+'px)';
        menu.style['overflow-y'] = 'auto';
      });
    }
  }, 1000);
  
});


// Zoom for each image

function addZoomingForCollectionProductsImages() {
  const modal = document.getElementById("image-zoom-modal");
  if(modal) {
    const modalImg = modal.querySelector("#modal-image");
    const closeIcon = modal.querySelector('.close');
    
    const clickableImages = document.querySelectorAll('.product-list-new .product-list__item .product-list__item-img img');

    clickableImages.forEach(image => {
      image.removeEventListener("click", () => {});
    });
                            
    clickableImages.forEach(image => {
      image.addEventListener('click', () => {
        modal.style.display = "block";
        modalImg.src = image.dataset.fullSrc;
        modalImg.alt = image.alt;
      });
    });
    
    closeIcon.onclick = function() {
      modal.style.display = "none";
    }
    modal.onclick = function(e) {
      modal.style.display = "none";
    }
  }
}


// Product list item Images slider

function activateSlideshow(productList) {
  let sliders = document.querySelectorAll('.collection-list-template .product-list__item .product-list__item-img');
  if(productList) sliders = productList.querySelectorAll('.product-list__item-img');
  sliders.forEach(function(slider) {
    
    const images = slider.querySelectorAll('img');
    const prevButton = slider.querySelector('.prev');
    const nextButton = slider.querySelector('.next');   

    if(images.length > 1) {
      
      let currentImageIndex = 0;
      
      function showImage(index) {
        images.forEach((image, i) => {
          image.style.display = i === index ? 'block' : 'none';
        });
      }
      
      prevButton.addEventListener('click', () => {
        currentImageIndex = (currentImageIndex - 1 + images.length) % images.length;
        showImage(currentImageIndex);
      });
      
      nextButton.addEventListener('click', () => {
        currentImageIndex = (currentImageIndex + 1) % images.length;
        showImage(currentImageIndex);   
      
      });
      
      showImage(currentImageIndex);
      
    }
  });
}


// Currency selector. Change placement

// (function () {

//   let waitForCurrencySelector = setInterval(function() {
//     let currencySelector = document.querySelector('.doubly-wrapper--desktop');
//     if(currencySelector) {

//       clearInterval(waitForCurrencySelector);

//       let newLi = document.createElement('li');
//       newLi.append(currencySelector);

//       setTimeout(() => {
//         document.querySelector('.tmenu_navbar').addEventListener('click', (event) => {
//           if (event.target.closest('.doubly-nice-select')) {
//             const el = event.target.closest('.doubly-nice-select');
//             newLi.querySelector('.doubly-nice-select').classList.toggle('open')
//             if (event.target.closest('li.option')) {
//               const select = event.target.closest('.doubly-wrapper').firstChild
//               // console.log(select, '21111')
//               select.value = event.target.closest('li.option').dataset.value;
//             }
//           }
//           console.log(event.target)
//         })
//       }, 800)

//       function changePlacement() {

//         let windowWidth = window.innerWidth;

//       //  console.log('windowWidth = '+windowWidth);
//         let headerNavEl = document.querySelector('.tmenu_navbar .tmenu_nav');
//         let headerNavLastEl = document.querySelector('.tmenu_navbar .tmenu_nav > li:last-child');
//         let currencyTextColor = '#fff';
//         let currencyBgColor = '#ffffff00';
//         if(windowWidth <= 640) {
//           headerNavEl = document.querySelector('#mobile-menu .mobile-menu__section:nth-child(4)');
//           headerNavLastEl = headerNavEl.querySelector('.mobile-menu__help-wrapper:last-child');
//           currencyTextColor = '#000';
//           currencyBgColor = '#fff';
//           headerNavEl.append(newLi);
//         } else if (windowWidth <= 1000) {
//           headerNavEl = document.querySelector('header .header__action-list');
//           headerNavLastEl = document.querySelector('header .header__action-list .header__mobile-account-link');
//           currencyTextColor = '#fff';
//           currencyBgColor = '#000';
//           headerNavEl.insertBefore(newLi, headerNavLastEl);
//         } else {
//           headerNavEl.insertBefore(newLi, headerNavLastEl);
//         }


//         setTimeout(function() {
//           // currencySelector.querySelector('.bacurr-dropdownChoices').style.setProperty('--bacurrBackground', currencyBgColor);
//           // currencySelector.querySelector('.bacurr-dropdownChoices').style.setProperty('--bacurrHover-bg', '#E30413');
//           // currencySelector.querySelector('.bacurr-dropdownChoices').style.setProperty('--bacurrSelect-color', currencyTextColor);
//           // if(windowWidth <= 640 || true) {
//           //   let selection = currencySelector.querySelector('.bacurr-dropdown-choices');
//           //   selection.style.setProperty('--bacurrBackground', 'inherit');
//           //   selection.style.setProperty('--bacurrHover-bg', 'inherit');
//           //   selection.style.setProperty('--bacurrSelect-color', 'inherit');
//           // }
//         }, 500);
//       }
//       changePlacement();

//       window.addEventListener("resize", (event) => {
//         changePlacement();
//       });
    
//     }
//   }, 1000);

// })();
